import { routeToUrl } from "@CommonUtils/routes";
import { useNavigate, type NavigateOptions } from "react-router-dom";

export const useNavigation = () => {
  const reactRouterDomNavigate = useNavigate();

  const navigate = (
    url: string,
    params?: { [key: string]: string | number },
    options?: NavigateOptions,
  ) => {
    reactRouterDomNavigate(routeToUrl(url, params), options);
  };

  const replaceUrlWithoutNavigation = (url: string) => {
    window.history.replaceState(window.history.state, "", url);
  };

  return {
    navigate,
    replaceUrlWithoutNavigation,
  };
};
